import * as React from 'react';
import { SessionServerSelectors, SessionSiteSelectors } from '../../../../app/selectors/SessionInfoSelectors';
import { Messages } from '../../../../codegen/Localize';
import { FormikCheckbox } from '../../../../commonInfra/components/FormikCheckbox';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { SettingsSection } from '../../../components/common/SettingsSection';
import { useSelector } from '../../utils';
import { SiteSettingsForSiteAdminProps } from '../ReactSiteSettingsForSiteAdmin';
import { componentRegistryEntry } from '../SettingsComponentRegistryFunctions';

export type NotificationsFlowRunsProps = SiteSettingsForSiteAdminProps<'notificationEnabled'>;

export function NotificationFlowRunsSection() {
  if (!useShowSettingsSection()) {
    return null;
  }
  const flowsOnSiteEnabled = useSelector(SessionSiteSelectors.isFlowOnSiteEnabled);

  return (
    <SettingsSection title={getTitle(flowsOnSiteEnabled)} description={getDescription(flowsOnSiteEnabled)} testId={'notifications-flow-runs-setting'}>
      <FormikCheckbox name={'settings.notificationEnabled'}
        label={getCheckboxLabel(flowsOnSiteEnabled)}
        testId={'enable-notification-checkbox'}
      />
    </SettingsSection>
  );
}

function useShowSettingsSection() {
  const isNotificationEnabledForServer = useSelector(SessionServerSelectors.isNotificationEnabledForServer);
  return  !FeatureFlags.userNotificationSettingsEnabled && isNotificationEnabledForServer;
}

function getTitle(flowsOnSiteEnabled: boolean) {
  return flowsOnSiteEnabled
    ? Messages.extractsOrFlowEmailNotificationSettingSection()
    : Messages.extractsEmailNotificationSettingSection();
}

function getDescription(flowsOnSiteEnabled: boolean) {
  return flowsOnSiteEnabled
    ? Messages.extractsOrFlowEmailNotificationSettingDetail()
    : Messages.extractsEmailNotificationSettingDetail();
}

function getCheckboxLabel(flowsOnSiteEnabled: boolean) {
  return flowsOnSiteEnabled
    ? Messages.extractsOrFlowEmailNotificationSettingEnable()
    : Messages.extractsEmailNotificationSettingEnable();
}

export const NotificationFlowRunsSpecs = componentRegistryEntry({
  name: 'NotificationFlowRunsSection',
  component: NotificationFlowRunsSection
});
